import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { BetslipType } from '../../../../../core/betslip-type';
import { isBetBuilderPick } from '../../../../../core/utils';
import { IBetslip } from '../../../../bet-generation/models';
import { getSlipBetslipType } from '../../../../bet-generation/services/slip.utils';
import { NoBetbuilderSystemPreCheckError } from '../../../errors/pre-check/no-betbuilder-system-pre-check-error';
import { IPureBetslipValidator } from './validators';

@Injectable()
export class NoBetbuilderSystemValidator implements IPureBetslipValidator<NoBetbuilderSystemPreCheckError> {
    constructor(private betslipConfig: BetslipConfig) {}

    validate(betslip: IBetslip): NoBetbuilderSystemPreCheckError[] {
        if (!this.betslipConfig.allowBetbuilderCombos) {
            return [];
        }

        const systemBetSlips = betslip.slips.filter((s) => getSlipBetslipType(s) === BetslipType.System);

        if (!systemBetSlips.length) {
            return [];
        }

        const hasBetBuilderPickInSystemSlip = systemBetSlips.some((slip) =>
            Object.values(slip.slipPicks).some((slipPick) => isBetBuilderPick(slipPick.pick)),
        );

        return hasBetBuilderPickInSystemSlip ? [new NoBetbuilderSystemPreCheckError()] : [];
    }
}
